<template>
  <SmartLinkItemComponent
      custom-tag="div"
      class="accordion-item"
      :id="model.system.id"
      :component="!model.system.workflow"
  >
        <div class="accordion-header">
            <button class="accordion-button" :class="{ collapsed: !options?.startExpanded || triggered }" @click="trigger" type="button"
                data-bs-toggle="collapse" :data-bs-target="`#d-${id}`" :id="`${id}`" :aria-expanded="options && options.startExpanded"
                :aria-controls="id">
                <span v-if="options?.numbering" class="number">{{ index + 1 }}.</span>
              <SmartLinkStandaloneElement
                  class="title"
                  :codename="typ.elements.title.codename"
              >  
              {{ data.title }}
              </SmartLinkStandaloneElement>
            </button>
        </div>
        <div :id="`d-${id}`" class="accordion-collapse collapse" :class="{ show: options?.startExpanded }"
            :data-bs-parent="`${parentId}`" :data-kontent-id="`d-${model.system.id}`">
            <div class="accordion-body">
              <SmartLinkStandaloneElement
                  :codename="typ.elements.content.codename"
              >
                <RichText :value="data.content" />
              </SmartLinkStandaloneElement>
            </div>
        </div>
  </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import { contentTypes} from '~/models';
import type {AccordionItemModel} from '~/models';
import type { AccordionOptions } from '~/models/options/accordionOptions';

const triggered = ref(false);
const props = defineProps<{ model: AccordionItemModel, index: number, parentId: string, options?: AccordionOptions }>();
const typ = contentTypes.accordion_item
const data = {
    title: props.model.elements.title.value,
    content: props.model.elements.content.value,
}

function trigger(){
    triggered.value =true;
}
const index = props.index;

const id = `q-${index + 1}`;




</script>
